import { FC, useMemo } from "react";

import { QuestionResults, Section } from "@/types/resources";
import NPSReport, { NPSReportData } from "./NPSReport";
import { countUniqueRespondents } from "./_respondentCount";

interface NPSSectionResultsProps {
  data: QuestionResults[];
  section: Section;
}

/* ── Cooker ─────────────────────────────────────────────── */

/** Folds every NPS-typed answer in the section into a 0..10 count
    histogram. Non-NPS questions in the section (rare for a templated
    NPS use-case section) are ignored. */
function cookNPSData(data: QuestionResults[] | undefined): NPSReportData {
  const scoreCounts = Array.from({ length: 11 }, () => 0);

  (data ?? []).forEach((r) => {
    if (r?.question?.type !== "nps") return;
    (r.groups ?? []).forEach((g) => {
      (g.answers ?? []).forEach((a) => {
        if (
          a.answer.type === "nps" &&
          typeof a.answer.rating === "number" &&
          a.answer.rating >= 0 &&
          a.answer.rating <= 10
        ) {
          scoreCounts[a.answer.rating] += 1;
        }
      });
    });
  });

  return { respondentCount: countUniqueRespondents(data), scoreCounts };
}

/* ── Component ──────────────────────────────────────────── */

const NPSSectionResults: FC<NPSSectionResultsProps> = ({ data }) => {
  const reportData = useMemo(() => cookNPSData(data), [data]);
  return <NPSReport data={reportData} />;
};

export default NPSSectionResults;
